import { getToken } from '../../features/auth/services/authService';

export const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchWithAuth = async (url, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...getAuthHeaders(),
    ...options.headers
  };

  let response = await fetch(url, {
    ...options,
    headers
  });

  if (response.status === 401 || response.status === 403) {
    // Token expired, invalid, or forbidden - remove token
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    
    // For GET requests to public endpoints, retry without token
    if (options.method === undefined || options.method === 'GET') {
      // Retry without authorization header
      const publicHeaders = {
        'Content-Type': 'application/json',
        ...options.headers
      };
      
      response = await fetch(url, {
        ...options,
        headers: publicHeaders
      });
    }
  }

  return response;
};